<template>
    <!-- Weekly Deals -->
    <section class="py-5">
        <div class="container">
            <div class="d-flex justify-content-between align-items-center mb-4">
                <h2 class="fw-bold font-serif">Save big with weekly deals</h2>
                <a href="#" class="text-decoration-none text-dark small fw-bold">View All <i
                        class="bi bi-arrow-right-circle-fill text-brown"></i></a>
            </div>
            <div class="row g-4">
                <div class="col-md-6">
                    <div class="p-5 rounded-4 bg-teal text-white position-relative overflow-hidden"
                        style="min-height: 250px;">
                        <div class="position-relative z-1">
                            <span class="badge bg-light text-dark mb-2">NEW</span>
                            <h3 class="fw-bold mb-3">Bathroom<br>vanities</h3>
                            <a href="#" class="btn btn-light rounded-pill btn-sm px-3">Shop Now</a>
                        </div>
                        <!-- Image placeholder -->
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="p-4 rounded-4 bg-danger text-white position-relative overflow-hidden h-100"
                        style="min-height: 250px;">
                        <div class="position-relative z-1">
                            <h4 class="fw-bold mb-3">Up to<br>70% off</h4>
                            <p class="small opacity-75">On soft furniture sets</p>
                            <a href="#" class="btn btn-outline-light rounded-pill btn-sm px-3 mt-2">View</a>
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="p-4 rounded-4 bg-primary-subtle text-dark position-relative overflow-hidden h-100"
                        style="min-height: 250px;">
                        <div class="position-relative z-1">
                            <h4 class="fw-bold mb-3">Big sale<br>30% off</h4>
                            <p class="small opacity-75">For new members</p>
                            <a href="#" class="btn btn-dark rounded-pill btn-sm px-3 mt-2">See More</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "WeeklyDealsSection"
}
</script>
